import { render, staticRenderFns } from "./IncidentReasonView.vue?vue&type=template&id=03ea416f&"
import script from "./IncidentReasonView.vue?vue&type=script&lang=js&"
export * from "./IncidentReasonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports